<template>
	<div class="row summary_pg program_guide_summary">
		<div class="col-12 tp_sec">

			<div class="row">

				<div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mb-2">
					<div class="row ml-1 mr-1">
						<div class="col-12 thumbnail_container" :class="'th_' + programGuide.uuid + ' ' + programGuide.type">
							<div class="thumbnail_img" v-if="programGuide.thumbnailURL" :class="setImageBgColor(programGuide.thumbnailURL)">
								<img :src="formattedProgramGuide.thumbnailURL" tabindex="0">
							</div>
							<div v-else class="thumbnail_default ico-degreeProgram" tabindex="0"></div>
						</div>
					</div>
				</div>

	    	<div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mb-2" v-if="showLMIBox && !programGuide.disableLMI">
					<div class="row ml-1 mr-1">
						<div class="col-12 other_info career_data">

							<div class="sec_hd row">
								<template v-if="showAlumniDataJobTitle">
									<div class="col-12">
										<div class="ace_sec_hd">
											<h3>{{alumniData.topCareerTitle}}</h3>
											<span class="hd_info">
												most popular alumni career
											</span>
										</div>
									</div>
								</template>
								<template v-else>
									<div class="col-11">
										<div class="ace_sec_hd">
											<h3 class="">US Data</h3>
										</div>

									</div>

									<div class="col-1 data_souce_info" style="margin-right: 0px; margin-top: -2px; padding: 0px;">
										<div id="dataSouceInfo" style="float: right;">
											<span class="ic ic8-info5"></span>
										</div>
										<b-popover target="dataSouceInfo" container="dataSouceInfoPopup" triggers="hover" style="margin-top: 20px;">
											<div class="popup_content">
												{{careerDataSource}}
											</div>
										</b-popover>
										<div id="dataSouceInfoPopup"></div>
									</div>
									<!-- ==== data_souce_info ==== -->
								</template>
							</div>

							<div class="bx_graphics">
								<div class="ic ic22-UsMap"></div>
								<div class="txt">National</div>
							</div>

			    		<div v-if="showMedianIncome" class="list_info_row" :aria-label="'median income ' + currencyLabel + formattedProgramGuide.medianIncomePerYear" tabindex="0">
			    			<div class="info_title lft_dir">{{medianIncomeLabel}}</div>
			    			<div class="info_val" v-if="formattedProgramGuide.medianIncomePerYear">
			    				{{currencyLabel}}<span v-html="addCommaInNumber(formattedProgramGuide.medianIncomePerYear)"></span>
			    			</div>
			    			<div class="info_no_val" v-else>N/A</div>
			    			<div class="info_title rgt_dir">{{medianIncomeLabel}}</div>
			    		</div>

			    		<div v-if="showJobPostings" class="list_info_row" :aria-label="'job postings ' + formattedProgramGuide.totalJobPostings" tabindex="0">
			    			<div class="info_title lft_dir">{{jobPostingsLabel}}</div>
			    			<div class="info_val" v-if="formattedProgramGuide.totalJobPostings">
			    				<span v-html="addCommaInNumber(formattedProgramGuide.totalJobPostings)"></span>
			    			</div>
			    			<div class="info_no_val" v-else>N/A</div>
			    			<div class="info_title rgt_dir">{{jobPostingsLabel}}</div>
			    		</div>

			    		<div v-if="showGrowthRate" class="list_info_row" :aria-label="'growth rate ' + formattedProgramGuide.growthRate" tabindex="0">
			    			<div class="info_title lft_dir"> {{growthRateLabel}} </div>
			    			<div class="info_val" v-if="formattedProgramGuide.growthRate">
									<span v-html="(Math.round(formattedProgramGuide.growthRate * 100) / 100).toFixed(1)"></span><span>%</span>
								</div>
			    			<div class="info_no_val" v-else>N/A</div>
			    			<div class="info_title rgt_dir"> {{growthRateLabel}} </div>
			    		</div>

			  			<div class="lnk_container">
			  				<a href="javascript:void(0);" @click="navigateToCareerProspects">more</a>
			  			</div>

					</div>
				</div>
			</div>

			<template v-if="((showEnrollmentBox && programGuide.pragyaProgram) || programGuide.additionalProgramDetail )">
		  	<div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mb-2">
					<div class="row ml-1 mr-1">
						<div class="col-12 other_info credential db_bx3">

							<div class="sec_hd row">
								<div class="col-12 align-center">
									<h3 class="ace_sec_hd" v-if="enrollmentStatus !== 'NOTENROLLED' && transactionValidity.transactionValid" style="text-align: center;">My Program Status</h3>
									<template v-if="isPricingAvailable || programGuide.freeProgram  || programGuide.paymentProcessedOutOfPragya">
		              <h3 class="ace_sec_hd" v-if="enrollmentStatus === 'NOTENROLLED' || !transactionValidity.transactionValid" style="text-align: center;">Get Started Now!</h3>
		              </template>
								</div>
		            <div class="col-12 align-center" v-if="!isPricingAvailable && !programGuide.freeProgram && !programGuide.paymentProcessedOutOfPragya">

		            </div>
		            <div class="col-12 price align-center">
		            	<span v-if="isPricingAvailable && programGuide.pricingPlans.length > 1 && !transactionValidity.includedWithSubscription">Starting at </span>
		              <span v-if="isPricingAvailable && programGuide.pricingPlans.length === 1 && !transactionValidity.includedWithSubscription">Price is </span>
									<span class="val" v-if="isPricingAvailable && !transactionValidity.includedWithSubscription" >{{minPrice}}</span>
		              <span v-else-if="!programGuide.freeProgram && isPricingAvailable && transactionValidity.includedWithSubscription"> included in the suscription plan</span>
		              <span v-else-if="programGuide.cost"> Cost <span class="fld_col_val">${{addCommaInNumber(programGuide.cost)}} </span></span>
		            </div>
							</div>
				  		<div class="row" aria-label="My Program Status" tabindex="0">
								<div class="col-11 program_status_select_bx" v-if="programGuide.pragyaProgram">
		              <div v-if="enrollmentStatus === 'NOTENROLLED' || !transactionValidity.transactionValid" class="subscribe_btn_container">
		                <template v-if="!programGuide.freeProgram">
		                  <template v-if="!showLoader">
		                    <div v-if="programGuide.paymentProcessedOutOfPragya" class="price_plan_sec">
		                      <div class="row sec_row">
		                        <div class="col-12 btn_container align-center">
		                          	<b-btn class="btn apply_btn" v-if="Object.keys(userSISProgramMapping).length === 0" @click.stop.prevent="createApplication">
		                            	<span class="btn_txt"> Apply </span>
		                          	</b-btn>
		                          <template v-if="Object.keys(userSISProgramMapping).length > 0">
		                            <template v-if="userSISProgramMapping.status === 'IN_PROGRESS'">
																	<div class="status_info">
		                              	<span class="txt"> Application In Progress </span>
																	</div>
																	<div class="btn_container">
			                              <b-btn @click.stop.prevent="resendApplicationLink">
			                                <span class="btn_txt"> Re-send application link</span>
			                              </b-btn>
																	</div>
		                            </template>
		                            <template v-if="userSISProgramMapping.status === 'SUBMITTED' || userSISProgramMapping.status === 'PENDING_DECISION'">
																	<div class="ic_container">
																		<span class="ic ic22-hour-glass"></span>
																	</div>
																	<div class="status_info">
																		<span class="txt">Decision Pending</span>
																	</div>
		                            </template>
		                            <template v-if="userSISProgramMapping.status === 'ACCEPTED' && userSISProgramMapping.feeStatus === 'UNPAID'">
		                              <div class="status_info">
																		<span class="txt">Application Approved</span>
																	</div>
																	<div class="btn_container">
			                              <b-btn :href="paymentUrl" target="_blank">
			                                <span class="btn_txt">Make Payment</span>
			                              </b-btn>
																	</div>
		                            </template>
		                            <template v-if="userSISProgramMapping.status === 'ACCEPTED' && (userSISProgramMapping.feeStatus === 'PAID' || userSISProgramMapping.feeStatus === 'WAIVED')">
																	<div class="ic_container">
																		<span class="ic ic22-hour-glass"></span>
																	</div>
																	<div class="status_info">
																		<span class="txt">Enrollment Pending</span>
																	</div>
		                            </template>
		                          </template>
		                        </div>
		                      </div>
		                    </div>
												<div v-if="!programGuide.paymentProcessedOutOfPragya" class="row price_plan_sec">
													<div class="col-12">
		                    		<template v-if="isPricingAvailable">
															<template v-if="transactionValidity.transactionValid">
															<div class="row sec_row">
																<div class="col-12 btn_container">
																	<b-btn @click.stop.prevent="confirmProgramSubscription">
																		<span class="btn_txt"> Start</span>
																	</b-btn>
																</div>
															</div>
															</template>
															<template v-else>
															<div class="row sec_row">
																<div class="col-12 btn_container">
																	<b-btn @click.stop.prevent="showBuyFlow">
																		<span class="btn_txt"> Buy </span>
																	</b-btn>
																</div>
															</div>
															</template>

														</template>
		                    		<template v-else>
															<div class="row sec_row">
																<div class="col-12 btn_container">
																	<b-btn>
																		<span class="btn_txt"> Coming Soon </span>
																	</b-btn>
																</div>
															</div>
														</template>

													</div>
												</div>
		                  </template>
		                  <template v-if="showLoader">
		                    <span class="text-black">Loading..</span>
		                  </template>
		                </template>
		                <template v-if="programGuide.freeProgram">
		                  <b-btn @click.stop.prevent="confirmProgramSubscription" class="btn_lg_22">
		          					<span class="btn_txt"> Start </span>
		          				</b-btn>
		                </template>
		              </div>
		              <div v-if="enrollmentStatus !== 'NOTENROLLED' && transactionValidity.transactionValid">
		                <div class="selected_val">
		                  <div class="val in_progress">In Progress</div>
		                </div>
		              </div>
		              <div class="alert_msg_sec2"
										v-if="enrollmentStatus !== 'NOTENROLLED' && !transactionValidity.transactionValid && transactionValidityLoaded"
										v-html="transactionValidity.institutionPurchaseExpirationMessage">
									</div>
		            </div>
								<div class="col-11 program_status_select_bx" v-if="!programGuide.pragyaProgram && enrollmentEnabled">
									<div class="selected_val">
										<div class="val not_enrolled" v-if="enrollmentStatus === 'NOTENROLLED'">Not Enrolled</div>
										<div class="val in_progress" v-if="enrollmentStatus === 'INPROGRSS'">In Progress</div>
										<div class="val completed" v-if="enrollmentStatus === 'COMPLETED'">Completed</div>
										<div class="val not_complete" v-if="enrollmentStatus === 'NOTCOMPLETED'">Couldn't Complete</div>
										<div class="ic ic22-dropdown2"></div>
									</div>
			  				  <select class="form-control" v-model="enrollmentStatus" @change="changeEnrollmentStatus" >
		                <option value="NOTENROLLED" selected>Not Enrolled</option>
		                <option value="INPROGRSS" >In Progress</option>
		                <option value="COMPLETED" >Completed</option>
		                <option value="NOTCOMPLETED" >Couldn't Complete</option>
		              </select>
								</div>
								<div class="col-11 program_status_select_bx" v-if="!programGuide.pragyaProgram && !enrollmentEnabled">
													<b-btn @click.stop.prevent="showLearnMore" class="btn_lg_22">
														<span class="btn_txt"> Learn More </span>
													</b-btn>

								</div>

		          </div>
							<div class="row">

								<!--
									<div class="col-12 lnk_container">
										<a href="javascript:void(0);" @click="learnMoreUrl()" v-if="!isStudent()">Copy LearnMore URL</a>
										<span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
										<a href="javascript:void(0);" @click="buyUrl()" v-if="!isStudent() && isPricingAvailable">Copy Buy URL</a>
									</div>
								-->

								<div class="col-12 lnk_container" v-if="isPricingAvailable">
									<a v-if="!transactionValidity.includedWithSubscription" href="javascript:void(0);" @click="openPricePlanDetailsModal" class="ace_sec">click for plan details</a>
								</div>
								<div class="col-12 filter_tags_container mt-1" v-else>
								 	<span class="filter_tag" v-if="programGuide.modalityType">{{getModalityValue(programGuide.modalityType)}}</span>
								 	<span class="filter_tag" v-if="programGuide.fundingType">{{getFundingValue(programGuide.fundingType)}}</span>
								</div>
							</div>
				  		<div class="lnk_container" v-if="programGuide.faqGroup && programGuide.faqGroup.faqGroups && programGuide.faqGroup.faqGroups.length > 0">
			  				<a href="javascript:void(0);" @click="navigateToFAQ">more</a>
			  			</div>

						</div>
					</div>
				</div>
		</template>
	</div>

		<template v-if="showCredentialBox || showComplianceBox">
		<!-- Credentials and Compliance -->
			<div class="row pg_row_cred">
				<div class="col-xl-8 col-lg-12 col-md-12 col-sm-12" v-if="showCredentialBox">
					<div class="row ml-1" style="margin-right: -10px;">
						<div class="col-12 other_info credential_sec">

							<div class="sec_hd row">
								<div class="col-12">
									<h3 class="ace_sec_hd">Credentials</h3>
								</div>
							</div>

							<div class="pg_list_container">
					  		<div v-for="credential in formattedProgramGuide.credentialList" class="row list_row" aria-label="Credential Title" tabindex="0">

									<div class="col-2 thumbnail_container">
							      <div class="thumbnail" v-if="credential.icon">
							        <img :src="credential.icon" tabindex="0">
										</div>
										<div v-else class="default_thumb">
											<span class="ic2 ic24-credential"></span>
										</div>
							    </div>

						      <div class="col-9 col_title d-flex align-items-center">
										{{credential.title}}
						      </div>

								</div>
							</div>

							<div class="lnk_container">
				  			<a href="javascript:void(0)" @click="navigateToFAQ">more</a>
				  		</div>

						</div>
					</div>
				</div>

				<div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 bx_validated_cred" v-if="programGuide.institutionSpecificInfo">
					<div class="row ml-1 mr-1">
						<div class="col-12 other_info credential db_bx3">
							<div class="sec_hd row">
								<div class="col-12">
									<h3 class="ace_sec_hd">{{complianceTabLabel}}</h3>
							  </div>
							</div>
							<div class="row">
								<div class="col-12 compliant_score_container">
									<div class="compliant_score_val">{{programGuide.institutionSpecificInfo.tag}}</div>
								</div>
							</div>
							<div class="lnk_container">
								<a href="javascript:void(0)" @click="navigateToCompliance">more</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
		<div class="image_filters_container">
			<!-- ======================= -->
			<!-- ==== Image Filters ==== -->
			<!-- ======================= -->

			<!-- ==== Purple ==== -->
			<svg>
				<filter id="fltPurple">
					<feColorMatrix
					type="matrix"
					values="1 -0.2 0 0 0
									0 1 0 -0.1 0
									0 1.2 1 0.1 0
									0 0 1.7 1 0 "/>
				</filter>
			</svg>
			<!-- ==== Purple ==== -->

			<!-- ==== Yellow ==== -->
			<svg>
				<filter id="fltYellow">
					<feColorMatrix
					type="matrix"
					values="1 0 0 0 0
									-0.2 1.0 0.3 0.1 0
									-0.1 0 1 0 0
										0 0 0 1 0 "/>
				</filter>
			</svg>
			<!-- ==== Yellow ==== -->

			<!-- ==== Cyan ==== -->
			<svg>
				<filter id="fltCyan">
					<feColorMatrix
						type="matrix"
						values="1 0 0 1.9 -2.2
										0 1 0 0.0 0.3
										0 0 1 0 0.5
										0 0 0 1 0.2 "/>
				</filter>
			</svg>
			<!-- ==== Cyan ==== -->

			<!-- ==== Black & White ==== -->
			<svg>
				<filter id="fltBlackAndWhite">
					<feColorMatrix
						type="matrix"
						values="0 1 0 0 0
										0 1 0 0 0
										0 1 0 0 0
										0 1 0 1 0 "/>
				</filter>
			</svg>
			<!-- ==== Black & White ==== -->

			<!-- ==== Old Times ==== -->
			<svg>
				<filter id="fltOldTimes">
					<feColorMatrix
						type="matrix"
						values="1 0 0 0 0
										-0.4 1.3 -0.4 0.2 -0.1
										0 0 1 0 0
										0 0 0 1 0 "/>
				</filter>
			</svg>
			<!-- ==== Old Times ==== -->

			<!-- ==== Cold Life ==== -->
			<svg>
				<filter id="fltColdLife">
					<feColorMatrix
						type="matrix"
						values="1 0 0 0 0
										0 1 0 0 0
										-0.2 0.2 0.1 0.4 0
										0 0 0 1 0 "/>
				</filter>
			</svg>
			<!-- ==== Cold Life ==== -->

			<!-- ==== Sepium ==== -->
			<svg>
				<filter id="fltSepium">
					<feColorMatrix
						type="matrix"
						values="1.3 -0.3 1.1 0 0
										0 1.3 0.2 0 0
										0 0 0.8 0.2 0
										0 0 0 1 0 "/>
				</filter>
			</svg>
			<!-- ==== Sepium ==== -->

			<!-- ==== Milk ==== -->
			<svg>
				<filter id="fltMilk">
					<feColorMatrix
						type="matrix"
						values="0 1.0 0 0 0
										0 1.0 0 0 0
										0 0.6 1 0 0
										0 0 0 1 0 "/>
				</filter>
			</svg>
			<!-- ==== Milk ==== -->

			<!-- ======================= -->
			<!-- ==== Image Filters Ends ==== -->
			<!-- ======================= -->
		</div> <!-- .image_filters_container -->


		<div>
      <b-modal id="warning-modal-popup" ref="WarningModal" size="lg" hide-footer no-close-on-backdrop no-close-on-esc>

				<div slot="modal-header" class="header-section w-100">
          <div class="row">
						<div class="col-10 hd">
	            <h5 class="hd_txt pt-1">Action not allowed</h5>
	          </div>
	          <div class="col-2">
	            <button class="btn_close mt-1" aria-label="close" @click="closeWarningModal">
	              <span class="ic-close"></span>
	            </button>
	          </div>
	        </div>
				</div>

				<div>
					<h6>This action is only available to learners</h6>
				</div>

			</b-modal>
    </div>
    <div>
      <b-modal class="subscribe_modal" id="subscribe-modal-popup" ref="subscribeModal" :header-bg-variant="'subscribe-popup-header'" size="xl" hide-footer no-close-on-backdrop no-close-on-esc>
        <div slot="modal-header" class="header-section w-100">
          <div class="credential_popup_head_txt">
            <span>Subscribe</span>
          </div>
          <div>
            <button class="btn_close" aria-label="close" @click="closeSubscribeModal">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>

          <!--
          <div class="row content_container">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 text-center">
							<div class="row prog_info">
								<div class="col-8 thumbnail_sec">
		  				    <div class="thumbnail_img" v-if="programGuide.thumbnailURL" :class="setImageBgColor(programGuide.thumbnailURL)">
		        				<img :src="formattedProgramGuide.thumbnailURL" tabindex="0">
		        			</div>
		        			<div v-else class="thumbnail_default ico-degreeProgram" tabindex="0"></div>
		            </div>
								<div class="col-8 title_sec">
									<div class="title_txt">{{programGuide.title}}</div>
								</div>
							</div>
						</div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 form_section">
              <h4>Order Summary</h4>
              <p>Monthly Subscription <span class="float-right">$250</span></p>
              <small>Note: You will be charged every month till you cancel your subscription</small>
              <div class="page_section_row description min-content mt-4">
                <div class="heading">
                  <label class="ace_sec_txt" for="roomInformation">Student Information</label>
                </div>
                <div class="value page_content_block">
                  <input
                    type="text"
                    class="lms-course-field"
                    placeholder="First Name"
                    :value="firstName"
                    >
                    <input
                      type="text"
                      class="lms-course-field"
                      placeholder="Last Name"
                      :value="lastName"
                      >
                </div>
                <div class="value page_content_block mt-2">
                  <input
                    type="text"
                    class="lms-course-field"
                    placeholder="Email"
                    :value="email"
                    >
                </div>
              </div>
              <div class="page_section_row description min-content mt-4">
                <div class="heading">
                  <label class="ace_sec_txt" for="roomInformation">Credit Card</label>
                </div>
                <div class="value page_content_block">
                  <input
                    type="text"
                    class="lms-course-field"
                    placeholder="Card Number"
                    >
                    <input
                      type="text"
                      class="lms-course-field"
                      placeholder="MM / YY"
                      >
                      <input
                        type="text"
                        class="lms-course-field"
                        placeholder="CVC"
                        >
                </div>
              </div>
              <div class="page_section_row description min-content mt-4">
                <div class="heading">
                  <label class="ace_sec_txt" for="roomInformation">Coupon</label>
                </div>
                <div class="value page_content_block">
                  <input
                    type="text"
                    class="lms-course-field"
                    placeholder="Coupon Code"
                    >
                    <a>Apply</a>
                </div>
              </div>
              <b-btn @click.stop.prevent="confirmProgramSubscription" class="float-left mt-4">
                <span class="btn_txt"> Pay & Subscribe </span>
              </b-btn>
            </div>
	  			</div>
          -->
          <!--<subscription :programCode="programGuide.code"></subscription>-->
      </b-modal>
    </div>

    <div>
      <b-modal class="subscribe_modal modal__v22_2 price_plan_modal" id="buy-modal-popup" ref="buyModal" :header-bg-variant="'subscribe-popup-header'" size="xl" hide-footer no-close-on-backdrop no-close-on-esc>

				<div slot="modal-header" class="w-100">
					<div class="row">

	          <div class="col-7 hd">
							<div class="ic_container">
								<span class="ic ic22-buy"></span>
							</div>
							<div class="hd_txt">
		            <span v-if="showPlansPage">Buying - Registration Details</span>
	              <span v-if="showSummaryPage">Buying - Payment Details</span>
	              <span v-if="showSuccessPage">Buying - Success!</span>
		          	</div>
						</div>
						<div class="col-5 btn_container">
							<template v-if="showPlansPage">
								<b-btn @click.stop.prevent="moveToSummaryPage">
									<span class="btn_txt">Next</span>
								</b-btn>
							</template>

							<template v-if="showSummaryPage">
                <template v-if="!showStripeSetupError">
									<template v-if="!showPaymentLoader">
										<b-btn @click.stop.prevent="moveToPlansPage">
                      <span class="btn_txt">Prev</span>
                    </b-btn>
                    <b-btn @click.stop.prevent="moveToSuccessPage">
											<span class="btn_txt">Submit & Register</span>
                    </b-btn>
									</template>
								</template>
							</template>

							<button class="btn_close" aria-label="close" title="close the popup" @click="closeBuyModal">
	              <span class="ic-close"></span>
	            </button>
						</div>
					</div>
				</div>

          <div class="row content_container">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 form_section">
              <template v-if="showPlansPage">
                <div class="row sub_hd">
									<div class="col-12 hd_txt">
										<div class="">{{programGuide.title}} Plans</div>
									</div>
								</div>

								<!--
								<div class="row sub_hd">
									<div class="col-6 hd_txt">
										<div class="">Plan</div>
									</div>
								</div>
							-->

								<div class="row price_plan_sec">
									<div class="col-12 sec_content">

										<div class="row">

											<div class="col-12">
												<div class="row sec_row sec_sub_hd" v-if="oneTimePlans.length > 0">
		                      One Time Plans
		                    </div>
												<div v-if="oneTimePlans.length > 0" class="row sec_row" v-for="pricingPlan in oneTimePlans">
													<div class="col-1 fld_radio">
														<input type="radio" name="plan" :value="pricingPlan" v-model="selectedPricingPlan">
													</div>
													<div class="col-10">
														{{pricingPlan.name}} - ${{pricingPlan.price}}
													</div>
												</div>
											</div>

											<div class="col-12">
												<div class="row sec_row sec_sub_hd" v-if="subscriptionPlans.length > 0">
		                      Subscription Plans
		                    </div>
												<div v-if="subscriptionPlans.length > 0" class="row sec_row" v-for="pricingPlan in subscriptionPlans">
													<div class="col-1 fld_radio">
														<input type="radio" name="plan" :value="pricingPlan" v-model="selectedPricingPlan">
													</div>
													<div class="col-10">
														{{pricingPlan.name}} - ${{pricingPlan.price}}
		                        <span v-if="pricingPlan.type === 'subscription-monthly'">/month</span>
		                        <span v-if="pricingPlan.type === 'subscription-monthly-payment-plan'">/month</span>
		                        <span v-if="pricingPlan.type === 'subscription-yearly'">/year</span>
													</div>
												</div>
											</div>

										</div>


										<div class="row">
											<div class="col-12 lnk_container">
												<a href="javascript:void(0)" @click="openPricePlanDetailsModal">plan details</a> <a v-if="institution.refundPolicyLink" target="_blank" :href="institution.refundPolicyLink" >| refund policy </a>
											</div>
										</div>

									</div>
								</div>


								<div class="row sub_hd student_info">
									<div class="col-6 hd_txt">
										<div class="">Student Information</div>
									</div>
								</div>

								<div class="row">
									<div class="col-12 sec_content">

										<div class="row fld_row">
											<div class="col-12 fld_label">
												 First Name*
											 </div>
											 <div class="col-12 fld_val">
												 <input
		                       type="text"
		                       class="lms-course-field"
		                       placeholder="First Name"
		                       :value="firstName"
		                       disabled
		                       >
										  </div>
										</div>

										<div class="row fld_row">
											<div class="col-12 fld_label">
												 Last Name*
											 </div>
											 <div class="col-12 fld_val">
												 <input
	                         type="text"
	                         class="lms-course-field"
	                         placeholder="Last Name"
	                         :value="lastName"
	                         disabled
	                         >
										  </div>
										</div>

										<div class="row fld_row">
											<div class="col-12 fld_label">
												 Email*
											 </div>
											 <div class="col-12 fld_val">
												 <input
		                       type="text"
		                       class="lms-course-field"
		                       placeholder="Email"
		                       disabled
		                       :value="email"
		                       >
										  </div>
										</div>

									</div>
								</div>
              </template>
              <template v-if="showSummaryPage">
                <template v-if="!showStripeSetupError">

									<template v-if="showPaymentLoader">
                    <p>Loading</p>
                  </template>

                  <div class="row fld_row">
                    <div class="col-12 fld_msg">
                      <p v-if="showMissingBillingInfoError" class="text-red">First Name & Last Name are required.</p>
                      <p v-if="showPaymentFailureError" class="text-red">Payment Failed. Please try again.</p>
                    </div>
                  </div>

									<div class="row sub_hd">
										<div class="col-6 hd_txt">
											<div class="">Order Summary</div>
										</div>
									</div>
									<div class="row">
										<div class="col-12 sec_content order_summary">
                      <div class="row sec_row">
												<div class="col-12 plan">
													{{programGuide.title}}
												</div>
											</div>
											<div class="row sec_row">
												<div class="col-6 plan">
													{{selectedPricingPlan.name}}
												</div>
												<div class="col-6 price">
													${{selectedPricingPlan.price}}
                          <span v-if="selectedPricingPlan.type === 'subscription-monthly'">/month</span>
                          <span v-if="selectedPricingPlan.type === 'subscription-monthly-payment-plan'">/month</span>
                          <span v-if="selectedPricingPlan.type === 'subscription-yearly'">/year</span>
												</div>
											</div>

                      <div class="row sec_row">
												<!--
												<div class="col-12 fld_label">
													 Coupon
												 </div>
											 	-->
												 <div class="col-12">
													 <div class="row fld_row">
														 <div class="col-8 fld_val">
															 <input
															 	type="text"
															 	class="lms-course-field"
															 	placeholder="enter discount coupon code"
															 	v-model="coupon"
															 	>
														 </div>
														 <div class="col-4 btn_container">
															 <b-btn @click.stop.prevent="applyCoupon">
	       	                      <span class="btn_txt">apply</span>
	       	                    </b-btn>
														 </div>
													 </div>


											  </div>
                        <div class="col-12 fld_label text-red" v-if="showCouponError">
                          Coupon is invalid. Try another one.
												 </div>
											</div>

											<div class="row sec_row" v-if="couponObj && couponObj.code ">
												<div class="col-8 coupon_code">
													{{couponObj.code}}
                          <b-btn class="ic_btn btn_trans" @click.stop.prevent="removeCoupon">
                           <span class="ic ic8-bin2"></span>
                         </b-btn>
												</div>
												<div class="col-4 coupon_price price">
													 - $ {{discountPrice}}
												</div>
											</div>

											<div class="row sec_row total">
												<div class="col-6 plan">
													Total
												</div>
												<div class="col-6 price">
													${{finalPrice}}
                          <span v-if="selectedPricingPlan.type === 'subscription-monthly'">/month</span>
                          <span v-if="selectedPricingPlan.type === 'subscription-monthly-payment-plan'">/month</span>
                          <span v-if="selectedPricingPlan.type === 'subscription-yearly'">/year</span>
												</div>
											</div>

										</div>
									</div>

                  <template v-if="finalPrice > 0">
  									<div class="row sub_hd">
  										<div class="col-6 hd_txt">
  											<div class="">Payment</div>
  										</div>
  									</div>
                    <template v-if="selectedPricingPlan.type !== 'onetime' && paymentMethodsToShow.length > 0 ">
                      <div class="row payment">
                        <div class="col-12 sec_content existing_ac_lst">
                          <div class="row fld_row">
                            <div class="col-12 fld_label">
                              Use an Existing Pay
                            </div>
                            <div class="col-12 row" v-for="userPaymentMethod in paymentMethodsToShow">
                              <div class="col-1 fld_radio">
    														<input type="radio" name="plan" :value="userPaymentMethod" v-model="selectedPaymentMethod">
    													</div>
                              <div class="col-xl-3 col-lg-5 col-md-11 col-sm-11 pt-2 sec_row">
                                <div class="card__number info_val2">
                                  <span class="info_title2 no_val">****</span>
                                  <span class="info_val2">{{userPaymentMethod.lastFour}}</span>
                                </div>
                              </div>
                              <div class="col-xl-3 col-lg-5 col-md-11 col-sm-11 pt-2 sec_row">
                                <div class="expiry_date">
                                  <span class="info_title2">expiry:</span>
                                  <span class="info_val2">{{userPaymentMethod.expiration}}</span>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                      <div class="row payment">
                        <div class="col-12 sec_content">
                          <div class="row fld_row">
                            <div class="col-12 fld_label" v-if="selectedPaymentMethod.uuid === ''">
                              Or
                            </div>
                            <div class="col-12 fld_label" v-if="selectedPaymentMethod.uuid !== ''">
                              <b-btn @click.stop.prevent="clearAndAddNewPayment">
                                <span class="btn_txt">Add new card instead</span>
                              </b-btn>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
  									<div class="row payment" v-if="selectedPaymentMethod.uuid === ''">
  										<div class="col-12 sec_content">
  											<div class="row fld_row">
  												<div class="col-12 fld_label">
  													Credit Card Details
  												</div>
  												<div class="col-12">
  													<div ref="card" id="card-element"></div>
  												</div>
  											</div>
  										</div>
  									</div>


  									<div class="row sub_hd">
  										<div class="col-6 hd_txt">
  											<div class="">Billing Information</div>
  										</div>
  									</div>
  									<div class="row">
  										<div class="col-12 sec_content">

  											<div class="row sec_row">
  												<div class="col-12 mb-2">
  													<input
                        			style="width:10%!important;"
                          		type="checkbox"
                          		class="lms-course-field"
                          		v-model="sameAsStudent"
                          	> same as student information
  												</div>
  											</div>

  											<div class="row fld_row">
  												<div class="col-12 fld_label">
  													 First Name*
  												 </div>
  												 <div class="col-12 fld_val">
  													 <input
  		                         type="text"
  		                         class="lms-course-field"
  		                         placeholder="First Name"
  		                         v-model="billingFirstName"
  		                         >
  											  </div>
  											</div>

  											<div class="row fld_row">
  												<div class="col-12 fld_label">
  													 Last Name*
  												 </div>
  												 <div class="col-12 fld_val">
  													 <input
  	                           type="text"
  	                           class="lms-course-field"
  	                           placeholder="Last Name"
  	                           v-model="billingLastName"
  	                           >
  											  </div>
  											</div>

  										</div>
  									</div>
                  </template>
								</template>
                <template v-if="showStripeSetupError">
									<div class="row sub_hd mt-3">
										<div class="col-6 hd_txt">
											<div class=""></div>
										</div>
									</div>
									<div class="row mb-5">
										<div class="col-12">
											<div class="row sec_row">
												<div class="col-12">
													There was error in setup. Please reach out to
													<a href="mailto:support@pragyasystems.com">support@pragyasystems.com</a>
												</div>
											</div>
										</div>
									</div>
                </template>
              </template>
              <template v-if="showSuccessPage">
								<div class="row sub_hd mt-2">
									<div class="col-6 hd_txt">
										<div class=""></div>
									</div>
								</div>
								<div class="row mb-5">
									<div class="col-12">
										<div class="row sec_row">
											<div class="col-12">
												Congratulations! You have successfully enrolled in {{programGuide.title}}. Get started now!
											</div>
										</div>

										<div class="row sec_row">
											<div class="col-12 btn_container2">
												<b-btn class="btn" @click="redirectToLearnerDashboard">Go to Home Page</b-btn>
											</div>
										</div>
									</div>
								</div>

							</template>
            </div>
	  			</div>

      </b-modal>
    </div>


		<!-- Price Plan Detials Modal -->
		<div>
			<b-modal id="pricePlanDetails" ref="pricePlanDetailsModal" class="subscribe_modal modal__v22_2 price_plan_modal price_plan_details_modal" :header-bg-variant="'credential-popup-header'" size="xl" hide-footer no-close-on-backdrop no-close-on-esc>

				<div slot="modal-header" class="w-100">
					<div class="row">
						<div class="col-10 hd">
							<div class="ic_container">
								<span class="ic ic22-buy"></span>
							</div>
							<div class="hd_txt">
								<span>Pricing Plan for {{programGuide.title}}</span>
							</div>
						</div>
						<div class="col-2 btn_container">
							<button class="btn_close" aria-label="close" title="close the popup" @click="closePricePlanDetailsModal">
								<span class="ic-close"></span>
							</button>
						</div>
					</div>
				</div>

				<div class="row content_container" style="max-width: 100%;">
					<div class="col-12">

						<div class="row" v-if="oneTimePlans.length > 0">
							<div class="col-12 sec_sub_hd">
								One Time Plans
							</div>
						</div>
						<div class="row plans_container" v-if="oneTimePlans.length > 0">
							<div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 plan_box" v-for="pricingPlan in oneTimePlans">
								<div class="plan_box_inner">

									<div class="row hd">
										<div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 sec_hd ace_sec">
			              	{{pricingPlan.name}}
										</div>
										<div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 price ace_sec">
											${{pricingPlan.price}}
										</div>
									</div>

									<div class="row description_long">
		              	<div class="col-12  ace_sec" v-html="pricingPlan.description"></div>
									</div>

									<div class="btn_container">
		              	<b-button @click="selectFromPricingPlan(pricingPlan)" class="btn  ace_sec">Select</b-button>
									</div>
		            </div>
							</div>
						</div>

						<div class="row" v-if="subscriptionPlans.length > 0">
							<div class="col-12 sec_sub_hd">
								Subscription Plans
							</div>
						</div>
						<div class="row plans_container" v-if="subscriptionPlans.length > 0">
							<div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 plan_box" v-for="pricingPlan in subscriptionPlans">
								<div class="plan_box_inner">

									<div class="row hd">
										<div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 sec_hd ace_sec">
			              	{{pricingPlan.name}}
										</div>
										<div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 price ace_sec">
											${{pricingPlan.price}}
                      <span v-if="pricingPlan.type === 'subscription-monthly'">/month</span>
                      <span v-if="pricingPlan.type === 'subscription-monthly-payment-plan'">/month</span>
                      <span v-if="pricingPlan.type === 'subscription-yearly'">/year</span>
										</div>
									</div>

									<div class="row description_long">
		              	<div class="col-12 ace_sec" v-html="pricingPlan.description"></div>
									</div>

									<div class="btn_container">
		              	<b-button @click="selectFromPricingPlan(pricingPlan)" class="btn ace_sec">Select</b-button>
									</div>
		            </div>
							</div>
						</div>

					</div>
				</div>

			</b-modal>
		</div>
		<!-- Plan Detials Modal -->


		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'
import { StorageFactory } from '../../../storageFactory'
import Subscription from '../../user/components/Subscription'

export const localStore = StorageFactory(() => localStorage)

export default {
  name: 'program-guide-summary',
  props: ['showThirdBox', 'showProgramAlumni'],
  components: {
    Subscription
  },
  data: () => {
    return {
    	enrollmentStatus: 'NOTENROLLED',
      userSubscriptions: [],
      showLoader: false,
      showPlansPage: true,
      showSummaryPage: false,
      showSuccessPage: false,
      selectedPricingPlan: {},
      stripe: undefined,
      elements: undefined,
      card: undefined,
      stripeCredentials: {},
      showStripeSetupError: false,
      billingFirstName: '',
      billingLastName: '',
      sameAsStudent: true,
      showMissingBillingInfoError: false,
      showPaymentFailureError: false,
      showPaymentLoader: false,
      subscriptionPlan : {},
      coupon: '',
      couponObj: {},
      showCouponError: false,
      transactionValidity: {},
      transactionValidityLoaded: false,
      userSISProgramMapping: {},
      paymentUrl: '',
      userPaymentMethods: [],
      selectedPaymentMethod: {
        uuid: ''
      }
    }
  },
  async mounted () {
  	await this.userEnrollmentStatus()
  },
  methods: {
  	...mapActions([
  		'loadSaveEnrollmentStatus',
      'loadUserSubscriptions',
      'loadGetInstitutionPaymentPublicCredentials',
      'loadPutCreatePaymentIntent',
      'loadPutFinalizePaymentIntent',
      'loadGetCheckValidityOfCoupon',
      'loadGetCouponCode',
      'loadCheckTransactionValidity',
      'loadLogDashboardActivity',
      'loadUserSISProgramMapping',
      'loadCreateApplication',
      'loadResendApplicationLink',
      'loadPaymentLink',
      'loadUserPaymentMethods',
      'loadCreateUserPaymentMethod',
      'loadCreateSubscription'
    ]),
    subscribeToProgram () {
      this.$refs.subscribeModal.show()
    },
    closeSubscribeModal () {
      this.$refs.subscribeModal.hide()
    },
    selectFromPricingPlan (pricingPlan) {
      if(!this.isStudent()){
    			this.openWarningModal()
    			return
    	}
      this.showPlansPage = true
      this.showSummaryPage = false
      this.showSuccessPage = false
      this.selectedPricingPlan = pricingPlan
      this.showMissingBillingInfoError = false,
      this.showPaymentFailureError = false
      this.$refs.buyModal.show()
    },
    showBuyFlow () {
      if(!this.isStudent()){
    			this.openWarningModal()
    			return
    	}
      this.showPlansPage = true
      this.showSummaryPage = false
      this.showSuccessPage = false
      if (this.programGuide.pricingPlans.length > 0) {
        this.selectedPricingPlan = this.programGuide.pricingPlans[0]
      }
      this.showMissingBillingInfoError = false,
      this.showPaymentFailureError = false
      this.$refs.buyModal.show()
    },
    closeBuyModal () {
      if (this.card) {
        this.card.unmount()
        $('#card-element').removeClass('form-control')
      }
      this.showPlansPage = true
      this.showSummaryPage = false
      this.showSuccessPage = false
      this.$refs.buyModal.hide()
    },
    async moveToSummaryPage () {
      this.userPaymentMethods = await this.loadUserPaymentMethods()
      this.stripeCredentials = await this.loadGetInstitutionPaymentPublicCredentials(this.programGuide.institutionId)
      if (this.stripeCredentials) {
        if (this.selectedPricingPlan.type === 'onetime') {
          this.stripe = Stripe(this.stripeCredentials.publicKey, {
            stripeAccount: this.stripeCredentials.accountId
          })
        } else {
          this.stripe = Stripe(this.stripeCredentials.publicKey)
        }
        this.elements = this.stripe.elements()
        setTimeout(() => {
          this.card = this.elements.create('card')
          this.card.mount('#card-element')
          $('#card-element').addClass('form-control')
          this.showCardLoader = false
        }, 1000);
      } else {
        this.showStripeSetupError = true
      }
      if (this.billingLastName.length < 1) {
        this.billingLastName = this.lastName
      }

      if (this.billingFirstName.length < 1) {
        this.billingFirstName = this.firstName
      }
      this.showPlansPage = false
      this.showSummaryPage = true
      this.showSuccessPage = false
    },
    moveToPlansPage () {
      this.card.unmount()
      $('#card-element').removeClass('form-control')
      this.selectedPaymentMethod = {
        uuid: ''
      }
      this.showPlansPage = true
      this.showSummaryPage = false
      this.showSuccessPage = false
    },
    async moveToSuccessPage () {
      if (this.billingFirstName.length <= 0 || this.billingLastName.length <= 0) {
        this.showMissingBillingInfoError = true
      } else {
        if (this.selectedPricingPlan.type === 'subscription-monthly' || this.selectedPricingPlan.type === 'subscription-yearly' || this.selectedPricingPlan.type === 'subscription-monthly-payment-plan'){
          this.showPaymentLoader = true
          this.loadLogDashboardActivity({action: 'stripeInit', page: 'prgramSummary', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code})
          this.showPaymentFailureError = false
          // Create/Update Payment Method
          if (this.selectedPaymentMethod.uuid === '') {
            let result = await this.stripe.createPaymentMethod({
              type: 'card',
              card: this.card,
              billing_details: {
                name: this.billingFirstName + ' ' + this.billingFirstName,
                email: this.email
              }
            })
            if (result.error) {
              this.showPaymentLoader = false
              this.showPaymentFailureError = true
              return
            } else {
              let paymentMethodObj = {
                paymentMethodId: result.paymentMethod.id
              }
              this.selectedPaymentMethod = await this.loadCreateUserPaymentMethod(paymentMethodObj)
            }
          }

          // Create Subscription (we dont calculate final price here because Stripe will adjust using stripe coupon)
          let finalPrice = this.finalPrice
          let couponId = this.couponObj && this.couponObj.code ? this.couponObj.uuid: ''

          let transactionObj = {
            entityId: this.programGuide.uuid,
            entityType: 'program',
            price: finalPrice,
            currency: this.selectedPricingPlan.currency,
            pricingPlanId: this.selectedPricingPlan.uuid,
            pricingPlanLearner: this.selectedPricingPlan,
            stripeProductId: this.selectedPricingPlan.stripeProductId,
            stripePriceId: this.selectedPricingPlan.stripePriceId,
            paymentMethodId: this.selectedPaymentMethod.uuid,
            type: 'firsttime',
            couponCodeId: couponId
          }

          let transactionResponse = await this.loadCreateSubscription(transactionObj)

          // Enroll user in program
          this.enrollmentStatus = 'INPROGRSS'
          let currentUserObj = JSON.parse(localStore.getItem('userobj'))
          currentUserObj.enrollmentStatus = 'INPROGRSS'
          currentUserObj.major1 = this.programCode
          localStore.setItem('userobj', JSON.stringify(currentUserObj))
          await this.loadSaveEnrollmentStatus({programCode: this.programGuide.code, status: this.enrollmentStatus})
          await this.$root.$emit('reloadLearnerDashboard')
          this.showPaymentLoader = false
          this.card.unmount()
          $('#card-element').removeClass('form-control')
          this.transactionValidity = await this.loadCheckTransactionValidity(this.programGuide.code)
          this.transactionValidityLoaded = true
          this.showPlansPage = false
          this.showSummaryPage = false
          this.showSuccessPage = true
          this.loadLogDashboardActivity({action: 'stripeSuccess', page: 'prgramSummary', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code})
          this.loadLogDashboardActivity({action: 'buyComplete', page: 'prgramSummary', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code})

        } else {
          this.showMissingBillingInfoError = false
          this.showPaymentLoader = true

          let finalPrice = this.finalPrice
          let couponId = this.couponObj && this.couponObj.code ? this.couponObj.uuid: ''

          let transactionObj = {
            entityId: this.programGuide.uuid,
            entityType: 'program',
            price: finalPrice,
            currency: this.selectedPricingPlan.currency,
            pricingPlanId: this.selectedPricingPlan.uuid,
            pricingPlanLearner: this.selectedPricingPlan,
            type: 'firsttime',
            couponCodeId: couponId
          }
          let transactionResponse = await this.loadPutCreatePaymentIntent(transactionObj)
          if (finalPrice > 0) {
            this.loadLogDashboardActivity({action: 'stripeInit', page: 'prgramSummary', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code})

            let result = await this.stripe.confirmCardPayment(transactionResponse.paymentIntentObject, {
              payment_method: {
                card: this.card,
                billing_details: {
                  name: this.billingFirstName + ' ' + this.billingFirstName,
                  email: this.email
                }
              }
            })

            if (result.error) {
              // Show error to your customer (e.g., insufficient funds)
              this.showPaymentFailureError = true
              this.showPaymentLoader = false
              this.loadLogDashboardActivity({action: 'stripeError', page: 'prgramSummary', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code, 'stripeError': result.error.code})

            } else {
              this.showPaymentFailureError = false
              // The payment has been processed!
              if (result.paymentIntent.status === 'succeeded') {
                // call finalize Sale
                await this.loadPutFinalizePaymentIntent(transactionResponse.uuid)
                // Enroll user in program
                this.enrollmentStatus = 'INPROGRSS'
                let currentUserObj = JSON.parse(localStore.getItem('userobj'))
                currentUserObj.enrollmentStatus = 'INPROGRSS'
                currentUserObj.major1 = this.programCode
                localStore.setItem('userobj', JSON.stringify(currentUserObj))
              	await this.loadSaveEnrollmentStatus({programCode: this.programGuide.code, status: this.enrollmentStatus})
              	await this.$root.$emit('reloadLearnerDashboard')
                this.showPaymentLoader = false
                this.card.unmount()
                $('#card-element').removeClass('form-control')
                this.transactionValidity = await this.loadCheckTransactionValidity(this.programGuide.code)
                this.transactionValidityLoaded = true
                this.showPlansPage = false
                this.showSummaryPage = false
                this.showSuccessPage = true
                this.loadLogDashboardActivity({action: 'stripeSuccess', page: 'prgramSummary', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code})
              	this.loadLogDashboardActivity({action: 'buyComplete', page: 'prgramSummary', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code})

              }
            }
          } else {
            // call finalize Sale
            await this.loadPutFinalizePaymentIntent(transactionResponse.uuid)
            // Enroll user in program
            this.enrollmentStatus = 'INPROGRSS'
            let currentUserObj = JSON.parse(localStore.getItem('userobj'))
            currentUserObj.enrollmentStatus = 'INPROGRSS'
            currentUserObj.major1 = this.programCode
            localStore.setItem('userobj', JSON.stringify(currentUserObj))
            await this.loadSaveEnrollmentStatus({programCode: this.programGuide.code, status: this.enrollmentStatus})
            await this.$root.$emit('reloadLearnerDashboard')
            this.showPaymentLoader = false
            this.card.unmount()
            $('#card-element').removeClass('form-control')
            this.transactionValidity = await this.loadCheckTransactionValidity(this.programGuide.code)
            this.transactionValidityLoaded = true
            this.showPlansPage = false
            this.showSummaryPage = false
            this.showSuccessPage = true
            this.loadLogDashboardActivity({action: 'buyComplete', page: 'prgramSummary', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code})

          }
        }
      }
    },
    clearAndAddNewPayment () {
      this.selectedPaymentMethod = {
        uuid: ''
      }
      this.showCardLoader = true
      this.elements = this.stripe.elements()
      setTimeout(() => {
        this.card = this.elements.create('card')
        this.card.mount('#card-element')
        $('#card-element').addClass('form-control')
        this.showCardLoader = false
      }, 1000);
    },
    async applyCoupon () {
      this.showCouponError = false
      // check if the coupon is valid
      let responsValidity = await this.loadGetCheckValidityOfCoupon({couponCode: this.coupon, programCode: this.programGuide.code, pricingPlanId: this.selectedPricingPlan.uuid})
      if (responsValidity) {
        // if the coupon is valid get coupon information
        this.couponObj = await this.loadGetCouponCode(this.coupon)
      } else {
        this.showCouponError = true
      }
    },
    async removeCoupon () {
      this.coupon = ''
      this.couponObj = {}
    },
    redirectToLearnerDashboard () {
      return this.$router.push({ name: 'learnerDashboard' })
    },
    async confirmProgramSubscription () {
    	if(!this.isStudent()){
    			this.openWarningModal()
    			return
    	}
      this.enrollmentStatus = 'INPROGRSS'
      let currentUserObj = JSON.parse(localStore.getItem('userobj'))
      currentUserObj.enrollmentStatus = 'INPROGRSS'
      currentUserObj.major1 = this.programCode
      localStore.setItem('userobj', JSON.stringify(currentUserObj))
    	await this.loadSaveEnrollmentStatus({programCode: this.programGuide.code, status: this.enrollmentStatus})
    	await this.$root.$emit('reloadLearnerDashboard')

    	this.$parent.showLoader()
    	setTimeout(() => {
    	  this.$parent.hideLoader()
          this.$router.push({ name: 'learnerDashboard' })
        }, 5000);
    },
    async userEnrollmentStatus () {
      this.showLoader = true
    	let status = 'NOTENROLLED'
    	if(this.learnerEnrollmentData) {
	    	this.learnerEnrollmentData.forEach(obj => {
	      	if (obj.programCode === this.programGuide.code) {
	        	status = obj.status
	      	}
	    	})
	    }
    	this.enrollmentStatus = status
      this.transactionValidity = await this.loadCheckTransactionValidity(this.programGuide.code)
      this.transactionValidityLoaded = true

      // If programGuide.paymentProcessedOutOfPragya is true, get userSISProgramMapping
      if (this.programGuide.paymentProcessedOutOfPragya) {
        this.userSISProgramMapping = await this.loadUserSISProgramMapping({sisProgramId:this.programGuide.sisProgramId, sisDegreeId:this.programGuide.sisDegreeId})

        if (Object.keys(this.userSISProgramMapping).length > 0) {
          if (this.userSISProgramMapping.status === 'ACCEPTED' && this.userSISProgramMapping.feeStatus === 'UNPAID') {
            this.paymentUrl = await this.loadPaymentLink({sisProgramId:this.programGuide.sisProgramId, sisDegreeId:this.programGuide.sisDegreeId})
          }
        }
      }

      this.showLoader = false
    },
    async createApplication () {
    	if(!this.isStudent()){
    			this.openWarningModal()
    			return
    	}
      if (!this.userSISProgramMapping) {
        this.showLoader = true
        this.userSISProgramMapping = await this.loadCreateApplication({sisProgramId:this.programGuide.sisProgramId, sisDegreeId:this.programGuide.sisDegreeId})
        await this.$root.$emit('reloadLearnerDashboard')
        return this.$router.push({ name: 'learnerDashboard' })
        this.showLoader = false
      }
    },
    async resendApplicationLink () {
    	if(!this.isStudent()){
    			this.openWarningModal()
    			return
    	}
      this.showLoader = true
      await this.loadResendApplicationLink({sisProgramId:this.programGuide.sisProgramId, sisDegreeId:this.programGuide.sisDegreeId})
      this.showLoader = false
      this.$notify({
        group: 'notify',
        type: 'succes',
        title: '',
        text: 'Please check your email for application link'
      })
    },
    async changeEnrollmentStatus () {
    	if(!this.isStudent()){
    			this.openWarningModal()
    			return
    	}
    	let currentEnrollmentInProgram = 'NOTENROLLED'
      	this.learnerEnrollmentData.forEach(obj => {
        	if (obj.programCode === this.programGuide.code) {
          	currentEnrollmentInProgram = obj.status
        	}
      	})

    	if ('NOTENROLLED' === this.enrollmentStatus && 'NOTENROLLED' === currentEnrollmentInProgram) {
    		return
    	}
    	await this.loadSaveEnrollmentStatus({programCode: this.programGuide.code, status: this.enrollmentStatus})
    	await this.$root.$emit('reloadLearnerDashboard')
    },
    isStudent () {
      return (localStore.getItem('userrole') === 'Student')
    },
    buyUrl (){
    	navigator.clipboard.writeText(window.location.host+'/vue/#/buy?orgId='+this.programGuide.institutionId+'&cipCode='+this.programGuide.cipCode+'&code='+this.programGuide.code+'&type='+this.programGuide.type);
    	this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: 'Buy URL Copied in clipboard',
        duration: 5000
      })

    },
    learnMoreUrl (){
    	navigator.clipboard.writeText(window.location.host+'/vue/#/learnMore?orgId='+this.programGuide.institutionId+'&cipCode='+this.programGuide.cipCode+'&code='+this.programGuide.code+'&type='+this.programGuide.type);
    	this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: 'Learn More URL Copied in clipboard',
        duration: 5000
      })
    },

    addCommaInNumber (numValue) {
      return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getExploreSearchPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getExploreSearchPackage(packages)
    },
    setImageBgColor (imageURL) {
      let getImageURL = imageURL.split('/')
      let getImageName = getImageURL[getImageURL.length - 1].match(/(.*)\.[\w]+$/)[1]
      return getImageName.replace(/\./g, '__')
    },
    openCredentialModal () {
    	this.$refs.credentialModal.show()
    },
    openIssuerUrl () {
    	window.open(this.programGuide.credential.url, '_blank')
    },
    closeCredentialModal () {
    	this.$refs.credentialModal.hide()
    },
    openWarningModal () {
    	this.$refs.WarningModal.show()
    },
    closeWarningModal () {
    	this.$refs.WarningModal.hide()
    },

		openPricePlanDetailsModal () {
			this.$refs.pricePlanDetailsModal.show()
		},
		closePricePlanDetailsModal () {
			this.$refs.pricePlanDetailsModal.hide()
		},
		navigateToFAQ () {
    	let routerParams = {
        cipCode: this.$parent.cipCode,
        programGuideCode: this.$parent.programGuideCode,
        type: this.$parent.type,
        returnTo: this.$parent.returnTo || 'exploreProgramGuideResults',
        showBackToResultButton: true,
        isWidget: this.$parent.isWidget,
        selected: this.$parent.selected
      }
      let queryParam = {
        returnTo: this.$route.query.returnTo || 'exploreProgramGuideResults'
      }
    	return this.$router.push({name: 'programGuideFAQ', params: routerParams, query: queryParam})
		},
		navigateToCompliance () {
    	let routerParams = {
        cipCode: this.$parent.cipCode,
        programGuideCode: this.$parent.programGuideCode,
        type: this.$parent.type,
        returnTo: this.$parent.returnTo || 'exploreProgramGuideResults',
        showBackToResultButton: true,
        isWidget: this.$parent.isWidget,
        selected: this.$parent.selected
      }
      let queryParam = {
        returnTo: this.$route.query.returnTo || 'exploreProgramGuideResults'
      }
    	return this.$router.push({name: 'programGuideCompliance', params: routerParams, query: queryParam})
		},


		showLearnMore () {
    	let routerParams = {
        cipCode: this.$parent.cipCode,
        programGuideCode: this.$parent.programGuideCode,
        type: this.$parent.type,
        returnTo: this.$parent.returnTo || 'exploreProgramGuideResults',
        showBackToResultButton: true,
        isWidget: this.$parent.isWidget,
        selected: this.$parent.selected
      }
      let queryParam = {
        returnTo: this.$route.query.returnTo || 'exploreProgramGuideResults'
      }
    	return this.$router.push({name: 'programGuideDegreeRequirements', params: routerParams, query: queryParam})
		},
		getModalityValue(key){
        let arr = [{key:"online", value:"Online"}, {key:"inperson", value:"In person"}, {key:"hybrid", value:"Hybrid"}]
        for(let i=0;i<arr.length;i++){
            if(arr[i].key===key){
                return arr[i].value
            }
        }
      return key
    },
    getFundingValue(key){
        let arr = [{key:"free", value:"Free"}, {key:"full", value:"Fully funded"}, {key:"partial", value:"Financial Aid"}]
        for(let i=0;i<arr.length;i++){
            if(arr[i].key===key){
                return arr[i].value
            }
        }
      return key
    },

    navigateToCareerProspects () {
    	let routerParams = {
        cipCode: this.$parent.cipCode,
        programGuideCode: this.$parent.programGuideCode,
        type: this.$parent.type,
        returnTo: this.$parent.returnTo || 'exploreProgramGuideResults',
        showBackToResultButton: true,
        isWidget: this.$parent.isWidget,
        selected: this.$parent.selected
      }
      let queryParam = {
        returnTo: this.$route.query.returnTo || 'exploreProgramGuideResults'
      }
    	return this.$router.push({name: 'programGuideCareerProspects', params: routerParams, query: queryParam})
    }
  },
  watch: {
    sameAsStudent (newSameAsStudent) {
      if (!newSameAsStudent) {
        this.billingFirstName = ''
        this.billingLastName = ''
      } else {
        this.billingFirstName = this.firstName
        this.billingLastName = this.lastName
      }
    }
  },
  computed: {
    ...mapState({
      'programGuide': state => state.programguide.programGuideObject,
      'alumniData': state => state.programguide.programAlumniData,
      'careersObject': state => state.programguide.careers,
      'packages': state => state.institution.packages,
      'institution': state => state.institution.institution,
      'enabledFeatures': state => state.institution.enabledFeatures,
      'learnerEnrollmentData': state => state.dashboard.learnerEnrollmentData
    }),
    oneTimePlans () {
      let plans = []
      if (this.programGuide.pricingPlans && this.programGuide.pricingPlans.length > 0) {
        this.programGuide.pricingPlans.forEach((item, i) => {
          if (item.type === 'onetime') {
            plans.push(item)
          }
        })
      }
      return plans
    },
    subscriptionPlans () {
      let plans = []
      if (this.programGuide.pricingPlans && this.programGuide.pricingPlans.length > 0) {
        this.programGuide.pricingPlans.forEach((item, i) => {
          if (item.type !== 'onetime') {
            plans.push(item)
          }
        })
      }
      return plans
    },
    hasAValidSubscription () {
      if (this.userSubscriptions.length > 0) {
        return true
      }
      return false
    },
    isBGTFeatureEnabled () {
      let bgtFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_BGT_SOURCE]
      return bgtFeature && bgtFeature.enabled
    },
    careerDataSource () {
      if (this.isBGTFeatureEnabled) {
        return 'Source: Burning Glass. 2018-2028'
      }
      return 'Source: BLS. 2016-2026'
    },
    showLMIBox () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.careerProspectsTab) {
        return false
      }
      return exploreProgramDetailFlagMap.careerProspectsTab.enabled
    },

    showAlumniDataJobTitle () {
    	let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.showAlumniData) {
        return false
      }
      return this.alumniData && this.alumniData.topCareerTitle && this.showProgramAlumni && exploreProgramDetailFlagMap.showAlumniData.enabled
    },
    showEnrollmentBox() {
    	return (this.enrollmentEnabled && this.showThirdBox)
    },
    enrollmentEnabled () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.allowEnrollment) {
        return false
      }
      return exploreProgramDetailFlagMap.allowEnrollment.enabled
    },
    multipleEnrollmentEnabled () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.allowMultipleEnrollment) {
        return false
      }
      return exploreProgramDetailFlagMap.allowMultipleEnrollment.enabled
    },
    showEnrollment () {
      let userObj = JSON.parse(localStore.getItem('userobj'))
      if(localStore.getItem('userrole') !== 'Student'){
      		return true
      }
      if(this.enrollmentEnabled && localStore.getItem('userrole') === 'Student'){
	    	if(this.multipleEnrollmentEnabled){
	    			return true
	    	}
      	let showFlag = false
      	if(!this.learnerEnrollmentData || this.learnerEnrollmentData.length==0){
      			showFlag = true
      	} else {
      		this.learnerEnrollmentData.forEach(obj => {
        		if (obj.programCode === this.programGuide.code) {
          		showFlag = true
        		}
      		})
      	}
      	return showFlag;
      }else{
      		return false
      }
    },
    exploreProgramDetailFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_DETAIL
      let exploreSearchPackage = this.getExploreSearchPackage()
      return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
    },
    showMedianIncome () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryMedianIncome) {
        return false
      }
      return exploreProgramDetailFlagMap.programDetailSummaryMedianIncome.enabled
    },
    medianIncomeLabel () {
      const defaultLabel = 'median income'
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryMedianIncome) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.programDetailSummaryMedianIncome.label || defaultLabel
    },
    complianceTabLabel () {
      const defaultLabel = 'Institution Info'
      if(this.programGuide.tabLabelMap && this.programGuide.tabLabelMap.institutionSpecificInfoLabel){
          return this.programGuide.tabLabelMap.institutionSpecificInfoLabel
      }
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.institutionSpecificInfo) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.institutionSpecificInfo.label || defaultLabel
    },
    showJobPostings () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryJobPostings) {
        return false
      }
      return exploreProgramDetailFlagMap.programDetailSummaryJobPostings.enabled
    },
    jobPostingsLabel () {
      const defaultLabel = 'job postings'
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryJobPostings) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.programDetailSummaryJobPostings.label || defaultLabel
    },
    showGrowthRate () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryGrowthRate) {
        return false
      }
      return exploreProgramDetailFlagMap.programDetailSummaryGrowthRate.enabled
    },
    growthRateLabel () {
      const defaultLabel = 'growth rate'
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryGrowthRate) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.programDetailSummaryGrowthRate.label || defaultLabel
    },
    currencyLabel () {
      return '$'
    },
    credentialTitle () {
    	if(this.programGuide.credential && this.programGuide.credential.title){
    		return this.programGuide.credential.title
    	}else{
    		return ''
    	}

    },
    credentialIssuer () {
    	if(this.programGuide.credential && this.programGuide.credential.issuer){
      return this.programGuide.credential.issuer
    	}else{
    		return ''
    	}
    },
    credentialType () {
    	if(this.programGuide.credential && this.programGuide.credential.type){
      return this.programGuide.credential.type.toLowerCase()
    	}else{
    		return ''
    	}
    },
    credentialTranscript () {
    	if(this.programGuide.credential && this.programGuide.credential.transcript){
      return this.programGuide.credential.transcript.toLowerCase()
    	}else{
    		return ''
    	}
    },
    credentialDelivery () {
    	if(this.programGuide.credential && this.programGuide.credential.deliveryType){
      return this.programGuide.credential.deliveryType.toLowerCase()
    	}else{
    		return ''
    	}
    },
    credentialDescription () {
    	if(this.programGuide.credential && this.programGuide.credential.description){
      return this.programGuide.credential.description
    	}else{
    		return ''
    	}
    },
    showCredentialBox () {
    		return (this.programGuide.credentialList.length>0)
    },
    showComplianceBox () {
    		return (this.programGuide.institutionSpecificInfo)
    },
    formattedProgramGuide () {
      let formattedProgramGuide = this.programGuide
      return formattedProgramGuide
    },
    firstName () {
      let currentUserObj = JSON.parse(localStore.getItem('userobj'))
      return currentUserObj.firstName
    },
    lastName () {
      let currentUserObj = JSON.parse(localStore.getItem('userobj'))
      return currentUserObj.lastName
    },
    email () {
      let currentUserObj = JSON.parse(localStore.getItem('userobj'))
      return currentUserObj.eMail
    },

    minPrice () {
      let minPrice = 0
      if (this.programGuide && this.programGuide.pricingPlans.length > 0) {
        minPrice = this.programGuide.pricingPlans[0].price
        this.programGuide.pricingPlans.forEach((item, i) => {
          if (item.price < minPrice) {
            minPrice = item.price
          }
        })
      }
      if (minPrice === 0) {
        return 'Free'
      }
      return '$' + minPrice
    },
    isPricingAvailable () {
      if (this.programGuide && this.programGuide.pricingPlans.length > 0) {
        return true
      }
    },
    finalPrice () {

      if (this.selectedPricingPlan && this.couponObj && this.couponObj.code) {
        let price = this.selectedPricingPlan.price
        if (this.couponObj.type === 'flat') {
          price = price - this.couponObj.value
          if (price < 0) {
            price = 0
          }
          price = price.toFixed(2)
        } else  if (this.couponObj.type === 'percentage') {
          let discount = (price * this.couponObj.value) / 100
          discount = discount.toFixed(2)
          price = price - discount
          if (price < 0) {
            price = 0
          }
          price = price.toFixed(2)
        }
        return price
      }

      if (this.selectedPricingPlan) {
        return this.selectedPricingPlan.price
      }
    },
    discountPrice () {
      if (this.selectedPricingPlan && this.couponObj && this.couponObj.code) {
        let price = this.selectedPricingPlan.price
        if (this.couponObj.type === 'flat') {
          return this.couponObj.value
        } else  if (this.couponObj.type === 'percentage') {
          let discount = (price * this.couponObj.value) / 100
          return discount.toFixed(2)
        }
      }

      return 0
    },
    paymentMethodsToShow () {
      let methods = []
      this.userPaymentMethods.forEach((item, i) => {
        let details = JSON.parse(item.stripePaymentMethod)
        item.expiration = details.card.exp_month + '/' + details.card.exp_year
        item.brand = details.card.brand
        methods.push(item)
      })
      return methods
    }
  }
}
</script>

<style>
	.credential_popup_head_txt {
    float: left;
    color: #323232;
    font-weight: 600;
    font-size: 1.8rem;
  }

  .bg-credential-popup-header {
  	background: #eaf8ff !important;
  }

  .txt-label-lft {
		text-align: right;
  }

  .txt-value-right {
  	color: #000;
  	text-align: left;
  }
  .text-black {
    color: #000;
  }

  .text-red {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideSummary.vue